import styled, { css } from 'styled-components';
import {
  FlexCenterAligned,
  FlexColumn,
  FlexibleDiv
} from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { tagStyles } from '../../../ui/Typography/styles';
import { Breakpoints } from '../../../../styled/constants';
import { ContactsButtonEnum } from './types';

export const ContactsContainer = styled(FlexColumn)`
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
  z-index: 3;
  gap: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    left: 30px;
    right: 30px;
    gap: 40px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    left: 20px;
    right: 20px;
    bottom: 20px;
    pointer-events: none;
  }
`;

export const ContactsTitle = styled(Typography)`
  ${tagStyles.h9};
  color: ${({ theme }) => theme.colors.background.primary};
  margin: 0;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const ContactsInfoContainer = styled(FlexibleDiv)`
  gap: 5px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 15px;
  }
`;

export const AllPhotoButton = styled(FlexCenterAligned)`
  display: none;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;

      background: linear-gradient(
        90deg,
        #d1d8fb 0%,
        #cbd4fc 17%,
        #c0caf8 41%,
        #b4c0f6 61%,
        #a4b3fa 100%
      );
    }
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    display: flex;
    height: 38px;
    border-radius: 14px;
    width: 102px;
    pointer-events: auto;
    background: linear-gradient(
      90deg,
      #ccdfe3 0%,
      #d7e7eb 17%,
      #e6f8f2 41%,
      rgba(231, 242, 238, 0.92) 61%,
      rgba(225, 235, 232, 0.76) 100%
    );
  }
`;

const contactsButtonsStyles = {
  [ContactsButtonEnum.layouts]: css`
    display: none;
  `,
  [ContactsButtonEnum.contacts]: css`
    background-color: ${({ theme }) => theme.colors.systemColors.green};

    &:hover {
      background-color: #269547;
    }
  `,
  [ContactsButtonEnum.items]: css`
    background-color: ${({ theme }) => theme.colors.systemColors.blue};

    &:hover {
      background-color: #3456ed;
    }
  `
};

export const ContactButton = styled(FlexCenterAligned)<{
  $variant: ContactsButtonEnum;
}>`
  height: 38px;
  padding: 0 15px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 29px;
  transition: all 0.2s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 48px;
    border-radius: 14px;
    padding: 0 35px;
    ${({ $variant }) => contactsButtonsStyles[$variant]};
    pointer-events: auto;
  }
`;

export const ContactButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.background.primary};
  text-decoration-line: underline;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    text-decoration-line: none;
  }
`;
